import { Person } from "@wingspanhq/wingspan-api-sdk";
import { getPersonFormEmptyValues } from "./emptyValues";
import { FormPartialDataPerson, FormPartialPersonType } from ".";

export function getProfileDataPersonV3(props: {
  type: FormPartialPersonType;
  person?: Person;
}): Partial<FormPartialDataPerson> {
  const { type, person } = props;

  if (type === "BeneficialOwner") {
    return {};
  }

  const complianceEntity = person?.complianceEntity;
  const address = complianceEntity?.physicalAddress;

  return {
    address: {
      ...getPersonFormEmptyValues().address,
      addressLine1: address?.line1 || "",
      addressLine2: address?.line2 || "",
      city: address?.city || "",
      state: address?.state || "",
      postalCode: address?.postalCode || ""
    },
    birthday: complianceEntity?.dateOfBirth || undefined,
    country: complianceEntity?.jurisdictionCountry || address?.country || "US",
    firstName: complianceEntity?.individualLegalName?.givenName || undefined,
    lastName: complianceEntity?.individualLegalName?.familyName || undefined,
    middleName: complianceEntity?.individualLegalName?.middleNames || undefined
  };
}
